const SUPPORTED_LANGUAGES = ['es', 'en', 'de', 'ja'];
const DEFAULT_LANGUAGE = 'en';

function normalizeLanguageCode(language) {
  if (!language || typeof language !== 'string') return null;

  const normalized = language.toLowerCase();
  const [baseLanguage] = normalized.split('-');

  if (SUPPORTED_LANGUAGES.includes(normalized)) return normalized;
  if (SUPPORTED_LANGUAGES.includes(baseLanguage)) return baseLanguage;

  return null;
}

export function getPreferredLanguage() {
  try {
    const savedLanguage = normalizeLanguageCode(localStorage.getItem('bruno_language'));
    if (savedLanguage) return savedLanguage;
  } catch (error) {
    // Ignore storage access errors and continue with browser detection.
  }

  const browserLanguages = [
    ...(navigator.languages || []),
    navigator.language,
    navigator.userLanguage,
  ].filter(Boolean);

  for (const language of browserLanguages) {
    const supportedLanguage = normalizeLanguageCode(language);
    if (supportedLanguage) return supportedLanguage;
  }

  return DEFAULT_LANGUAGE;
}

export { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES, normalizeLanguageCode };
